export const PART_DAY_OPTION_SUFFIX = '|part-day'

export function toPartDayOptionId(leaveTypeId: string): string {
  return `${leaveTypeId}${PART_DAY_OPTION_SUFFIX}`
}

export function isPartDayOptionId(optionId: string): boolean {
  return optionId.endsWith(PART_DAY_OPTION_SUFFIX)
}

export function basePartDayOptionId(optionId: string): string {
  return isPartDayOptionId(optionId) ? optionId.slice(0, -PART_DAY_OPTION_SUFFIX.length) : optionId
}
